import React from "react"
import { TableSeekerContextProvider } from 'ui-seeker/core'
import {useAppContextState} from "app/@hooks";
import {createContext} from "use-context-selector";

const Context = createContext({})
const initialState = { tableData: [], isLoading: true, dates: [], mainHotelIds: [], idMainHotel: null }

export function CompetitionAnalyzerCompetitionDailyTableProvider({children}) {
	const { state, updateState } = useAppContextState(initialState)

	return <Context.Provider value={{state, updateState}}>
		<TableSeekerContextProvider>
			{children}
		</TableSeekerContextProvider>
	</Context.Provider>
}

export default Context